import { useEffect, useState } from 'react';

import { Text, Accordion, AccordionContent, AccordionItem, AccordionTrigger, Progressbar } from 'atp-react-ui';

import { RESULTS_MAPPING_APIKEY } from '@/_mappers/api-result-mappers';
import { CATEGORIES } from '@/_mappers/category-mapper';
import PurpleMinus from '@/_static/assets/purpleMinus.svg?react';
import PurplePlus from '@/_static/assets/purplePlus.svg?react';
import { getFormData, getDetailedScoresFiltered } from '@/_utils';
import { replaceWithName } from '@/_utils/actions';

const data = [
  {
    title: CATEGORIES.GENERAL_EDUCATION,
    body: `Use our Credit by Exam prep courses to fast track your Gen Eds.`,
    average: null,
    score: 24,
  },
  {
    title: CATEGORIES.ENTRANCE_EXAM,
    body: `Use our live online instructor led prep courses to pass your Entrance Exam the 1st time.`,
    average: null,
    score: 38,
  },
  {
    title: CATEGORIES.CORE_RN_COURSES,
    body: `Use our on-demand knowledge base to get real-time Core Nursing Course answers.`,
    average: null,
    score: 50,
  },
  {
    title: CATEGORIES.EXIT_EXAM,
    body: `Use our live online instructor led prep courses to pass your Nursing Licensure Exam the 1st time.`,
    average: null,
    score: 82,
  },
];

const scoreAverage = (n) => {
  let s = '';
  if (n <= 25) {
    s = 'Low';
  } else if (n > 25 && n < 65) {
    s = 'Medium';
  } else if (n >= 65) {
    s = 'High';
  }
  return s;
};

export function ResultsCard({ currentObj, leadObj }) {
  const formData = getFormData();

  // const scoreMap = buildScoreMap(formData);
  const allScores = getDetailedScoresFiltered(formData);
  // console.log({ allScores });
  // update scoring
  for (const obj of data) {
    const { title } = obj;
    const score = allScores[title]?.totalScore;
    obj.average = scoreAverage(score);
    obj.score = score;
  }

  return (
    <>
      <Text as="h1" className="font-semibold text-primary">
        {replaceWithName(currentObj.header, leadObj)}
      </Text>

      <Text
        className="pb-8 pt-2 text-base text-secondary-dark"
        dangerouslySetInnerHTML={{ __html: replaceWithName(currentObj.subheader, leadObj) }}
      />

      <Accordion type="multiple" collapsible="true" className="w-full">
        {data.map((obj, index) => {
          const { title, body, average, score } = obj;
          const adjustedTitle = title === CATEGORIES.EXIT_EXAM ? CATEGORIES.LICENSURE_EXAM : title;
          let n_score = score;
          let n_average = average;

          if (RESULTS_MAPPING_APIKEY.get(title) != null) {
            const api_key = RESULTS_MAPPING_APIKEY.get(title);
            const labelValue = formData[api_key];

            if (labelValue) {
              if (labelValue.includes(`I've passed`) && labelValue !== `I've passed some, but not all of them.`) {
                n_score = 100;
                n_average = 'COMPLETED';
              }
            }
          }

          return (
            <AccordionItem key={title} value={`item-${index + 1}`}>
              <AccordionTrigger className="py-2">
                <div className="flex w-full flex-col">
                  <NewProgress value={n_score} isComplete={n_average === 'COMPLETED'} />
                  <div className="mt-1 flex w-full items-center justify-between">
                    <div
                      className={`${
                        n_average === 'COMPLETED' ? 'text-secondary' : 'text-primary'
                      } flex items-center gap-x-3 text-base font-medium`}
                    >
                      <span className="group-data-[state=open]:hidden">
                        <PurplePlus />
                      </span>
                      <span className="group-data-[state=closed]:hidden">
                        <PurpleMinus />
                      </span>
                      {adjustedTitle}
                    </div>

                    <span
                      className={`font-sans italic ${
                        n_average === 'COMPLETED' ? 'text-secondary' : 'text-primary-medium'
                      }`}
                    >
                      {n_average}
                    </span>
                  </div>
                </div>
              </AccordionTrigger>
              <AccordionContent>
                <div className="pb-4 pl-5 pt-0 text-base font-medium text-accent-light">{body}</div>
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </>
  );
}

function NewProgress({ value, isComplete }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setProgress(value);
    }, 100);
  }, [value]);
  return (
    <Progressbar
      value={progress}
      indicatorClassName={isComplete ? 'bg-secondary-medium' : ''}
      className={isComplete ? 'bg-secondary-x-light' : ''}
    />
  );
}
